import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  getPanelErrorProps,
  TextTitle,
  ValidatedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { getHeadlinesCardSummaryDetails } from '@bingads-webui-campaign-react/validated-text-collection';
import { HeadlineAssetCollection } from './headline-asset-collection';
import TextAssetsImg from '../media/text-assets.svg';

export const HeadlineAssetCollectionSection = React.memo((props) => {
  const {
    featureName, enableCopilotRecommendations, headlines, expand, setAddNewShortHeadlinesCallback, enableCustomizer, ...rest
  } = props;
  const i18n = useContext(I18nContext);
  const headlinesCardSummaryDetails = useMemo(() => getHeadlinesCardSummaryDetails(i18n, headlines), [headlines, i18n]);

  return (
    <ValidatedPanel
      key="headlines"
      title={<TextTitle
        titleKey={_TL_('Short headlines')}
        icon={TextAssetsImg}
        iconAltText={i18n.getString(_TL_('Short headlines'))}
        details={headlinesCardSummaryDetails}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'headlines',
      }}
      {...rest}
    >
      <HeadlineAssetCollection
        showDeleteButton={enableCopilotRecommendations}
        featureName={featureName}
        setAddNewShortHeadlinesCallback={setAddNewShortHeadlinesCallback}
        enableCustomizer={enableCustomizer}
      />
    </ValidatedPanel>
  );
});

HeadlineAssetCollectionSection.propTypes = {
  featureName: PropTypes.string,
  enableCopilotRecommendations: PropTypes.bool,
  headlines: PropTypes.shape({}).isRequired,
  expand: PropTypes.func.isRequired,
  setAddNewShortHeadlinesCallback: PropTypes.func.isRequired,
  enableCustomizer: PropTypes.bool,
};

HeadlineAssetCollectionSection.defaultProps = {
  featureName: undefined,
  enableCopilotRecommendations: true,
  enableCustomizer: true,
};
